$(function(){

/* header purrweb begin */

const buttonOpen = $('.btn-open-menu');
const buttonClose = $('.btn-close-menu');
// const menu = $('.menu');

buttonOpen.on('click', function(event){
  console.log('open');
  buttonOpen.css('display', 'none');
  buttonClose.css('display', 'block');
  $('.header').addClass('is-open')
  // menu.addClass('is-open');
  // $('body').addClass('body-hidden');
});

buttonClose.on('click', function(event){
  console.log('close');
  buttonClose.css('display', 'none');
  buttonOpen.css('display', 'block');
  $('.header').removeClass('is-open')
  // menu.removeClass('is-open');
  // $('body').removeClass('body-hidden');
});

// $('.menu__item').on('click', function(event){
//   menu.removeClass('is-open');
//   $('body').removeClass('body-hidden');
// });

// if (window.matchMedia("(max-width: 992px)").matches) {
//   $('.link-contact_en').html('Contacts');
// }

// $('#link-contact').on('click', function (event) {
//   event.preventDefault();
//   var servicesOffset = $('.purrweb-footer').offset().top;
//   $('html, body').animate({
//       scrollTop: servicesOffset
//   }, 800);
//   $('.field_name').focus();
// })
});


// WEBPACK FOOTER //
// ./app/assets/js/mobile-menu.js